import Vue from 'vue'
import Component from 'vue-class-component'
import ArticleVue from './Article.vue'
import { ARTICLE_ID } from '../../store/editor/components/state'
import { PreviewContentType } from './PreviewInterface'

// Vuex （$store） に格納された記事データから、外部出力用のHTMLを生成する

@Component({
  components: {
    'article-preview': ArticleVue
  }
})
export default class HtmlGeneratorVue extends Vue {
  readonly previewContentType?: PreviewContentType
  content: string = ''
  frozen: boolean = false

  get articleId(): string {
    return ARTICLE_ID
  }

  beforeMount(): void {
    this.content = ''
    this.frozen = false
  }

  mounted(): void {
    // innerHTML のスナップショットを保存する。こうすることで、 JavaScript で DOM が書き換わるのを防ぐ。
    this.content = this.$el.innerHTML.trim()
    this.frozen = true
  }
}
